import { IntegrationType, IIntegration } from "@src/interfaces";
import { SwapIntegration } from "./Swap";
import { LidoIntegration } from "./Lido";

/**
 * Factory for creating integration instances
 */
export class IntegrationFactory {
  /**
   * Create an integration instance based on type
   */
  static createIntegration(type: IntegrationType): IIntegration {
    switch (type) {
      case IntegrationType.Swap:
        return new SwapIntegration();

      case IntegrationType.Lido:
        return new LidoIntegration();

      default:
        console.warn(`Unknown integration type: ${type}, falling back to Swap`);
        return new SwapIntegration();
    }
  }

  /**
   * Get all available integration types
   */
  static getAvailableTypes(): IntegrationType[] {
    return [IntegrationType.Swap, IntegrationType.Lido];
  }
}
